import './HeaderGenericLegislation.css';
import React from 'react';
import { get } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { getFormatedDate } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
var HeaderGenericLegislation = function HeaderGenericLegislation(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('HeaderGenericLegislation component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'pageTitle.value'));
  var hasBusinessUnit = Boolean(get(fields, 'businessUnit.fields.fullName.value'));
  var hasAnnouncementType = Boolean(get(fields, 'announcementType.fields.fullName.value'));
  var hasReferenceNumber = Boolean(get(fields, 'referenceNumber.value'));
  var hasTags = Boolean(get(fields, 'tagsDot.length'));
  var hasDateOfIssue = Boolean(get(fields, 'dateOfIssue.value'));
  var hasIslamicDate = Boolean(get(fields, 'islamicDate.value'));
  var hasLocation = Boolean(get(fields, 'location.fields.country.value') && get(fields, 'location.fields.city.value'));
  var hasRecipients = Boolean(get(fields, 'recipients.value'));
  var hasPageIntro = Boolean(get(fields, 'pageIntro.value'));
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header--legislation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h3 hl__title",
    tag: "h1",
    field: fields.pageTitle
  }), hasPageIntro && /*#__PURE__*/React.createElement("div", {
    className: "hl__desc"
  }, /*#__PURE__*/React.createElement(RichText, {
    className: "body-large desc__txt",
    tag: "div",
    field: fields.pageIntro
  })), /*#__PURE__*/React.createElement("p", {
    className: "label-large hl__infos"
  }, hasAnnouncementType && /*#__PURE__*/React.createElement(React.Fragment, null, fields.announcementType.fields.fullName.value, /*#__PURE__*/React.createElement("br", null)), hasBusinessUnit && /*#__PURE__*/React.createElement(React.Fragment, null, fields.businessUnit.fields.fullName.value, /*#__PURE__*/React.createElement("br", null)), hasReferenceNumber && /*#__PURE__*/React.createElement(React.Fragment, null, fields.referenceNumber.value, /*#__PURE__*/React.createElement("br", null)), hasTags && fields.tagsDot.map(function (item, index) {
    var isLastItem = fields.tagsDot.length === index + 1;
    return "".concat(item.fields.fullName.value).concat(isLastItem ? '' : ' • ');
  }), /*#__PURE__*/React.createElement("br", null), hasDateOfIssue && "".concat(getFormatedDate(fields.dateOfIssue.value, sitecoreContext.language), ","), ' ', hasIslamicDate && "".concat(fields.islamicDate.value, ","), ' ', hasLocation && "".concat(fields.location.fields.country.value, " - ").concat(fields.location.fields.city.value)), hasRecipients && /*#__PURE__*/React.createElement("div", {
    className: "content-to"
  }, /*#__PURE__*/React.createElement(RichText, {
    className: "body-small",
    tag: "div",
    field: fields.recipients
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle)
  }, children);
};
var commonStyles = "cxsz6dn";
var ltrStyles = "lh3ehn9";
var rtlStyles = "r1nwvjs7";
export default HeaderGenericLegislation;